module.exports = __webpack_public_path__ + "static/media/delete.352adfe7.svg";